import { render } from "./MainPanel.vue?vue&type=template&id=2b78ae52&scoped=true"
import script from "./MainPanel.vue?vue&type=script&lang=js"
export * from "./MainPanel.vue?vue&type=script&lang=js"

import "./MainPanel.vue?vue&type=style&index=0&id=2b78ae52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b78ae52"]])

export default __exports__